import slugify from "slugify";

class Helpers {
  formatResponse = (response, type = "main-ring") => {
    if (response) {
      let formattedResponse = response;
      if (type === "main-ring") {
        formattedResponse = this.mapCollectionToItem(response);
        formattedResponse = this.mapImagesURLs(formattedResponse, true);
      } else if (type === "holder-ring") {
        formattedResponse = this.mapCollectionToItem(response);
        formattedResponse = this.mapImagesURLs(formattedResponse, false);
      } else if (type === "necklace") {
        formattedResponse = this.mapCollectionToItem(response);
        formattedResponse = this.mapNecklaceImageURLs(response, "necklace");
      } else if (type === "memory") {
        formattedResponse = this.mapCollectionToItem(response);
        formattedResponse = this.mapNecklaceImageURLs(response, "memory");
      }
      formattedResponse = this.formatStoreFrontIds(formattedResponse);

      return formattedResponse;
    }

    return response;
  };

  /**
   * Add collection title to model.
   */
  mapCollectionToItem = (data) => {
    if (
      data.items &&
      data.items.length &&
      data.includes &&
      data.includes.Entry &&
      data.includes.Entry.length
    ) {
      for (let i = 0; i < data.items.length; i++) {
        for (let y = 0; y < data.includes.Entry.length; y++) {
          if (
            data.items[i].fields &&
            data.items[i].fields.collection &&
            data.items[i].fields.collection.sys.id ===
              data.includes.Entry[y].sys.id
          ) {
            data.items[i].fields.collectionTitle = slugify(
              data.includes.Entry[y].fields.title
            );
          }
        }
      }
      return data;
    }

    return data;
  };

  /**
   * Maps image urls to mainring or holder ring model.
   */
  mapImagesURLs = (response, mainRing = true) => {
    if (response.items && response.includes && response.includes.Asset) {
      const imageKeys = mainRing
        ? [
            "imagePlatinum",
            "imagePlatinumDiamond",
            "imagePlatinumShadow",
            "imageRoseGold",
            "imageRoseGoldDiamond",
            "imageRoseGoldShadow",
            "imageWhiteGold",
            "imageWhiteGoldDiamond",
            "imageWhiteGoldShadow",
            "imageYellowGold",
            "imageYellowGoldDiamond",
            "imageYellowGoldShadow",
          ]
        : [
            "imagePlatinumLower",
            "imagePlatinumUpper",
            "imagePlatinumShadow",
            "imageWhiteGoldUpper",
            "imageWhiteGoldLower",
            "imageWhiteGoldShadow",
            "imageRoseGoldUpper",
            "imageRoseGoldLower",
            "imageRoseGoldShadow",
            "imageYellowGoldUpper",
            "imageYellowGoldLower",
            "imageYellowGoldShadow",
          ];
      for (let i = 0; i < response.includes.Asset.length; i++) {
        for (let y = 0; y < response.items.length; y++) {
          for (let x = 0; x < imageKeys.length; x++) {
            response.items[y] = this.findImageAsset(
              response.items[y],
              response.includes.Asset[i],
              imageKeys[x]
            );
          }
        }
      }
    }
    // fallback to returning the response
    return response;
  };

  mapNecklaceImageURLs = (response, type = "necklace") => {
    if (response) {
      const imageKeys =
        type === "necklace"
          ? ["imageYellowGold", "imageRoseGold", "imageWhiteGold"]
          : [
              "imageYellowGoldMain",
              "imageYellowGoldSide",
              "imageRoseGoldMain",
              "imageRoseGoldSide",
              "imageWhiteGoldMain",
              "imageWhiteGoldSide",
            ];
      for (let i = 0; i < response.includes.Asset.length; i++) {
        for (let y = 0; y < response.items.length; y++) {
          for (let x = 0; x < imageKeys.length; x++) {
            response.items[y] = this.findImageAsset(
              response.items[y],
              response.includes.Asset[i],
              imageKeys[x]
            );
          }
        }
      }
    }

    return response;
  };

  /**
   * Adds image url to fieldsItem model.
   */
  findImageAsset = (fieldsItem, assetsItem, key) => {
    if (
      fieldsItem &&
      fieldsItem.fields &&
      fieldsItem.fields[key] &&
      assetsItem &&
      key
    ) {
      if (fieldsItem.fields[key].sys.id === assetsItem.sys.id) {
        fieldsItem.fields[`${key}URL`] =
          "https://" + assetsItem.fields.file.url.substring(2);
        return fieldsItem;
      }
    }
    return fieldsItem;
  };

  /**
   * Decodes storefront ids so that they can be used in buy url parameters.
   */
  formatStoreFrontIds = (response) => {
    if (response && response.items && response.items.length) {
      for (let i = 0; i < response.items.length; i++) {
        if (response.items[i].fields) {
          if (response.items[i].fields.shopifyProductPlatinum) {
            response.items[i].fields.shopifyProductPlatinum = atob(
              response.items[i].fields.shopifyProductPlatinum
            ).split("/")[4];
          }
          if (response.items[i].fields.shopifyProductYellowGold) {
            response.items[i].fields.shopifyProductYellowGold = atob(
              response.items[i].fields.shopifyProductYellowGold
            ).split("/")[4];
          }
          if (response.items[i].fields.shopifyProductWhiteGold) {
            response.items[i].fields.shopifyProductWhiteGold = atob(
              response.items[i].fields.shopifyProductWhiteGold
            ).split("/")[4];
          }
          if (response.items[i].fields.shopifyProductRoseGold) {
            response.items[i].fields.shopifyProductRoseGold = atob(
              response.items[i].fields.shopifyProductRoseGold
            ).split("/")[4];
          }
        }
      }
    }

    return response;
  };
}

export default Helpers;
